import { Component, input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CardSummarySinglelineComponent } from "src/app/core/card-summary-singleline/card-summary-singleline.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { Subject, take } from 'rxjs';
import { GridColConfig } from 'src/app/core/custom-grid/custom-grid';
import { CustomOverlayMessaggeComponent } from 'src/app/core/custom-overlay-messagge/custom-overlay-messagge.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { GestioneEnigmiService } from './gestione-enigmi.service';
import { EnigmaDto } from './enigmi-dto';
import { MatMenuModule } from "@angular/material/menu";
import { ToastService } from 'src/app/core/toast/toast.service';



@Component({
  selector: 'app-gestione-enigmi',
  imports: [CardSummarySinglelineComponent, MatIconModule, MatButtonModule, MatMenuModule],
  templateUrl: './gestione-enigmi.component.html',
  styleUrl: './gestione-enigmi.component.scss'
})
export class GestioneEnigmiComponent implements OnInit, OnDestroy {

  @ViewChild(CustomOverlayMessaggeComponent) overlayMessagge: CustomOverlayMessaggeComponent | undefined;
  readonly idStep = input.required<string>();

  options: GridColConfig[] = [];
  enigmi: EnigmaDto[] = [];

  private theEnd$ = new Subject<void>();


  constructor(
    private localstorage: LocalStorageService,
    private router: Router,
    private enigmiService: GestioneEnigmiService,
    private toast:ToastService
  ) {
  }



  ngOnInit(): void { //TODO make lazy loading


    this.localstorage.setTitolo('Gestione enigmi');

    this.enigmiService.getAllByStep(this.idStep()).pipe(take(1)).subscribe({
      next: (data: EnigmaDto[]) => {
        this.enigmi = data;
      }
    })


    this.options = [
      {
        type: 'button',
        name: 'Modifica',
        field: 'none',
        icon: 'pencil',
        cssClass: 'edit-button',
        fieldOptions: {
        },
        width: '40'
      },
      {
        type: 'text',
        name: 'Nome',
        field: 'name',
        fieldOptions: {
        }
      },
      {
        type: 'text',
        name: 'Descrizione',
        field: 'description',
        fieldOptions: {
        }
      },
      {
        type: 'button',
        name: 'Elimina',
        field: 'none',
        icon: 'trash',
        cssClass: 'delete-button',
        fieldOptions: {
        },
        width: '40'
      }
    ];
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }


  btnClick(event: any) {
    if (event.action == 'modifica') {
      this.edit(event.data.id)
    }
    if (event.action == 'elimina') {

      this.overlayMessagge?.showDialog();
      this.overlayMessagge!.deleteItem = event.data.id;
    }

  }

  unlockTypeToString(ut: string): string {
    switch (ut) {
      case 'gps': return 'GPS';
      case 'immediate': return 'Immediato';
      case 'time': return 'Tempo';
      case 'qr': return 'QR Code';
      default: return 'Immediato';
    }
  }

  edit(id: string): void {
    this.router.navigate([`/home/enigmi/${id}`]);
  }


  add(): void {
    this.router.navigate([`/home/enigmi/new`, this.idStep()]);
  }

  delete(id: string) {
    this.enigmiService.delete(id).pipe(take(1)).subscribe({
      next: () => {
        this.toast.success('Enigma eliminato');

        this.enigmiService.getAllByStep(this.idStep()).pipe(take(1)).subscribe({
          next: (data: EnigmaDto[]) => {
            this.enigmi = data;
          }
        })
      }
    })
  }



}
